export const unrestrictedRoutes = [
  "/auth",
  "/login",
  "/sign-up",
  "/updatepassword",
  "/forgotpassword",
  "/reset",
  "/record",
  "/auth1",
  "/verify",
  "/imaging/usthyroid-Preview",
  "/imaging/usabdominal-Preview",
  "/imaging/usabdominal-doppler-Preview",
  "/imaging/usaorta-Preview",
  "/imaging/bladderPreliminary-Preview",
  "/imaging/breastus-Preview",
  "/imaging/renalDopplerus-Preview",
  "/imaging/LwrExtrmVnsDpler-Preview",
  "/imaging/testicularUltrasound-Preview",
  "/imaging/prostateTransAbdominal-Preview",
  "/imaging/orthous-Preview",
  "/imaging/estim-Preview",
  "/imaging/uspelvic-Preview",
  '/imaging/echo-Preview',
  '/imaging/venous-Preview',
  '/imaging/carotid-Preview',
  '/imaging/arterial-Preview',
  "/imaging/strep-covid-flu-Preview",
  "/doc/homesleepq",
  "/patient",
  "/patient1111",
  "/patient-enrollment",
  "/medTrack/",
];
